import * as React from 'react';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import MaskedInput from 'react-text-mask';
import Input from '@material-ui/core/Input';
import { ChangeEvent, ChangeEventHandler, SyntheticEvent } from 'react';

function TextMaskCustom(props: any) {
  const { onChange, ...other } = props;

  return (
    <MaskedInput
      {...other}
      // ref={ref => {
      //   inputRef(ref ? ref.inputElement : null);
      // }}
      onChange={onChange}
      mask={['+', '3', '8', ' ', '(', '0', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
}

type Props = {
  // using `interface` is also ok
  value: string,
  onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> ,
    phone: boolean,
    valid: boolean,
}

type State = {
  validationStarted: boolean,
};

class InputComponent extends React.Component<Props, State> {

  // constructor() {
  //   super();
  //
  //   this.state: State = {validationStarted: false}
  // }

  state: State = { validationStarted: false };

  prepareToValidate = () => {
  };

  componentDidUpdate(prevProps: Props) {
    const { value } = this.props;
    if (value !== prevProps.value) {
      //this.startValidation();
      this.prepareToValidate = _.debounce(this.startValidation, 500);
    }
  }

  startValidation = () => {
    this.setState({
      validationStarted: true,
    });
  };

  componentDidMount = () => {

    // let startValidation = function(){
    //   this.setState({
    //     validationStarted: true
    //   })
    // }.bind(this);

    // if non-blank value: validate now
    // if (this.props.value) {
    //   startValidation();
    // }
    // wait until they start typing, and then stop
    // else {
    this.prepareToValidate = _.debounce(this.startValidation, 500);
    // }
  };


  handleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
    if (!this.state.validationStarted) {
      this.prepareToValidate();
    }
    this.props.onChange && this.props.onChange(e);
  };

  render() {
    // console.log(this.props.phone);
    return (
      <React.Fragment>
        {this.props.phone
          ? <Input
            {...this.props}
            onChange={this.handleChange}
            value={this.props.value}
            //required={required}
            inputComponent={TextMaskCustom}
            error={this.state.validationStarted ? this.props.valid : false}
          />
          : <TextField
            {...this.props}
            onChange={this.handleChange}
            value={this.props.value}
            //required={required}
            error={this.state.validationStarted ? this.props.valid : false}
          />
        }
      </React.Fragment>
    );
  }
}

export default InputComponent;
